export default "__VITE_ASSET__BzYc1RdI__"